export interface FAQItem {
    question: string;
    answer: string;
    summary?: string;
}

export interface FAQGroup {
    icon: string;
    title: string;
    items: FAQItem[];
}

export const faqGroups: FAQGroup[] = [
    {
        icon: '🚀',
        title: 'Getting Started',
        items: [
            {
                question: 'What is Upshift?',
                summary: 'The app in one sentence.',
                answer: 'Upshift is an all-in-one productivity app that helps you transform your life from the bottom up. Your habits become quests, you earn XP and level up, and distracting apps stay blocked until the important stuff is done.'
            },
            {
                question: 'Is there an Android version?',
                summary: 'iPhone and Android.',
                answer: 'Yes! Upshift is available on the App Store and on Google Play.'
            },
            {
                question: 'Is there a free version of Upshift?',
                summary: 'Trial and pricing.',
                answer: 'Upshift offers 7 days of free trial, to show you why this is the app you were looking for :)'
            },
            {
                question: 'How do XP and levels work?',
                summary: 'Progress, badges and stats.',
                answer: 'Every quest you complete earns XP in its category: Money, Strength, Health or Knowledge. XP raises your global level, unlocks badges and achievements, and shows up on your profile with the rest of your stats.'
            }
        ]
    },
    {
        icon: '⚔️',
        title: 'Quests & Habits',
        items: [
            {
                question: 'What is the difference between Quests and Sidequests?',
                summary: 'Main habits vs daily challenges.',
                answer: 'Quests are your main daily habits you want to build long-term. Sidequests are daily challenges generated by the app, offering extra XP and keeping things interesting. Complete sidequests for bonus rewards and variety!'
            },
            {
                question: 'What kinds of quests can I create?',
                summary: 'One-day, weekly, monthly, quit and roulette.',
                answer: 'One day quests work like a to-do list and can be scheduled for future days. Weekly and monthly quests run on the days you pick. Quit quests help you break bad habits by tracking them daily, and roulette quests throw random challenges at you. You can also browse Explore to discover new habits.'
            },
            {
                question: 'Will Upshift remind me to do my quests?',
                summary: 'Smart reminders.',
                answer: 'Yes. Smart reminders nudge you to complete your habits without being annoying.'
            },
            {
                question: 'What happens when I keep a streak?',
                summary: 'Celebrations and badges.',
                answer: 'Streak and day celebrations pop up when you stay consistent or finish your daily goals, and milestones unlock badges and achievements.'
            }
        ]
    },
    {
        icon: '🛡️',
        title: 'App Blocker',
        items: [
            {
                question: 'What is the Quest Blocker?',
                summary: 'Apps stay blocked until quests are done.',
                answer: 'Quest Blocker is our unique feature that blocks distracting apps until you complete your daily quests. It\'s a powerful motivator to get your important tasks done first before accessing entertainment apps.'
            },
            {
                question: 'What other blocks can I set up?',
                summary: 'Block Now, time limits, schedules and more.',
                answer: 'Block Now instantly blocks apps when you need to focus. Time Limits cap daily usage for apps and websites. Work Schedule blocks distracting apps during work hours. There are also pre-built blocks such as the porn blocker, and each block type has its own custom overlay.'
            },
            {
                question: 'Can I get around a block?',
                summary: 'Strict mode.',
                answer: 'With strict mode on, a block cannot be bypassed until the app is unblocked (depending on the block type). That is the point, even on the easiest settings.'
            },
            {
                question: 'Can I trust you with my screen time data?',
                summary: 'Built on Apple Screen Time.',
                answer: 'You don\'t have to! Upshift is built on top of Apple\'s Screen Time technology. Apple built it with privacy in mind, so we can\'t view your screen time even if we wanted to.'
            }
        ]
    },
    {
        icon: '🎯',
        title: 'Goals & Focus',
        items: [
            {
                question: 'How do goals work?',
                summary: 'Milestones and a journal.',
                answer: 'Set long-term goals and break them into micro-goals. Each goal has a journal where you write your plan and reflections, and you get deadline reminders along the way.'
            },
            {
                question: 'Can I track my time?',
                summary: 'Time tracker and focus timer.',
                answer: 'Yes. The time tracker shows where your day goes, and the focus timer times your sessions so you can see how productive you were.'
            }
        ]
    },
    {
        icon: '👥',
        title: 'Friends & Profile',
        items: [
            {
                question: 'Can I use Upshift with friends?',
                summary: 'Friends, groups and leaderboards.',
                answer: 'Add friends, share your progress, and join groups with shared challenges and leaderboards to stay accountable.'
            },
            {
                question: 'Can I customize the app?',
                summary: 'Themes and widgets.',
                answer: 'Pick from 9 themes for your profile and add Upshift widgets to your home screen.'
            },
            {
                question: 'What is the Affiliate Program?',
                summary: 'Earn rewards by sharing Upshift.',
                answer: 'Share Upshift with others and earn rewards through our Affiliate Program. When people sign up using your referral code/username, you earn credits that can be used to redeem a bunch of rewards.'
            }
        ]
    }
];

export const faqItems: FAQItem[] = faqGroups.flatMap((g) => g.items);
